export const ChevronLeftIcon = ({
  fill = 'none',
  width = '36',
  height = '36',
  viewBox = '0 0 36 36',
  circleFill = 'white',
  pathStroke = '#373D40',
}) => (
  <svg width={width} height={height} viewBox={viewBox} fill={fill} xmlns="http://www.w3.org/2000/svg">
    <g id="Icon container">
      <circle id="Ellipse 20" cx="18" cy="18" r="17.5" fill={circleFill} stroke="#EDEFF1" />
      <path
        id="Vector"
        d="M19.8885 24.6113L13.2773 18.0002L19.8885 11.3891"
        stroke={pathStroke}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)
